/**
 * @generated SignedSource<<43cb21a21101e3023e00aca587b8eeb7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type MultiSelectFieldConfigFragment$data = {
  readonly id: string;
  readonly multiSelectOptions: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"MultiSelectFieldOptionFragment">;
  }>;
  readonly name: string;
  readonly " $fragmentType": "MultiSelectFieldConfigFragment";
};
export type MultiSelectFieldConfigFragment$key = {
  readonly " $data"?: MultiSelectFieldConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MultiSelectFieldConfigFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MultiSelectFieldConfigFragment",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2MultiSelectFieldOption",
      "kind": "LinkedField",
      "name": "multiSelectOptions",
      "plural": true,
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "MultiSelectFieldOptionFragment",
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2MultiSelectField",
  "abstractKey": null
};
})();

(node as any).hash = "6e996f435b2587115daca7f67e044959";

export default node;
